export default __webpack_public_path__ + "static/media/AG2.936cf20f.jpg";